module.exports = __webpack_public_path__ + "img/about-bg-mobile.15932c6c.jpg";